import { useSelector } from 'react-redux';

import { ViewTypeName } from '@air/api/types';

import { useIsSearchActive } from '~/hooks/search/useIsSearchActive';
import { currentViewTypeNameSelector } from '~/store/configViews/selectors';

export type UseShowExpandNestedContentToggleParams = {
  isDisabled?: boolean;
};

export const useShowExpandNestedContentToggle = ({
  isDisabled = false,
}: UseShowExpandNestedContentToggleParams = {}) => {
  const { isSearchActive } = useIsSearchActive();
  const currentViewTypeName = useSelector(currentViewTypeNameSelector);
  const isKanbanView = currentViewTypeName === ViewTypeName.kanban;

  return {
    showExpandNestedContentToggle: !isSearchActive && !isKanbanView && !isDisabled,
  };
};
